import { StatsCountMiniXD, TypePlaceMiniXD } from "models/mini-xd-model";
import clickAudio from 'assets/images/audio/click.mp3';

const xdFunction = {
    xdFade: [
        { methodname: 'even', odds: '1:0.96', order: 1, level1: 1.96, levelnum: 1, maxbet: 50000000, currentBet: 0 },
        { methodname: 'odd', odds: '1:0.96', order: 2, level1: 1.96, levelnum: 1, maxbet: 50000000, currentBet: 0 },
        { methodname: '3white1red', odds: '1:2.9', order: 3, level1: 3.9, levelnum: 1, maxbet: 50000000, currentBet: 0 },
        { methodname: '1white3red', odds: '1:2.9', order: 4, level1: 3.9, levelnum: 1, maxbet: 50000000, currentBet: 0 },
        { methodname: 'white', odds: '1:14', order: 5, level1: 15, levelnum: 1, maxbet: 50000000, currentBet: 0 },
        { methodname: 'red', odds: '1:14', order: 6, level1: 15, levelnum: 1, maxbet: 50000000, currentBet: 0 },
    ],
    effectChipBet: (
        htmlString: string,
        pageDom: HTMLElement,
        listChip: any[],
        placeEl: HTMLElement,
        typeBet: TypePlaceMiniXD,
        chipValue: number,
        scale: number
    ) => {
        let chipActiveEl = listChip.find((chipEl: HTMLButtonElement) => {
            return Number(chipEl.getAttribute('datatype')) === chipValue;
        });

        const cloneChip = document.createElement('div');
        const coordinatesChipActive = chipActiveEl.getBoundingClientRect();
        cloneChip.innerHTML = htmlString;
        cloneChip.style.position = 'absolute';
        cloneChip.style.top = coordinatesChipActive.top + 'px';
        cloneChip.style.left = coordinatesChipActive.left + 'px';
        cloneChip.style.width = coordinatesChipActive.width - 5 + 'px';
        cloneChip.style.height = coordinatesChipActive.height - 5 + 'px';
        cloneChip.style.zIndex = '1001';
        cloneChip.setAttribute('data-typebet', typeBet);
        cloneChip.classList.add('chipEmbed', 'wrap-chip');
        pageDom.appendChild(cloneChip);
        const coordinatesEl = placeEl.getBoundingClientRect();
        const getXYMove = xdFunction.randomPosiElRect(coordinatesEl, coordinatesChipActive.width * scale);
        cloneChip.style.transform = `scale(${scale})`;
        cloneChip.style.left = getXYMove.x + 'px';
        cloneChip.style.top = getXYMove.y + 'px';

        setTimeout(() => {
            let newY = getXYMove.y - coordinatesEl.top;
            let newX = getXYMove.x - coordinatesEl.left;

            if (newX < -12) newX = 0;
            else if (newX > coordinatesEl.width - 25) {
                newX = coordinatesEl.width - 50;
            }

            if (newY < -12) newY = -12;
            else if (newY > coordinatesEl.height) {
                newY = getXYMove.y - coordinatesEl.top - 25;
            }

            cloneChip.style.left = newX + 'px';
            cloneChip.style.top = newY + 'px';
            placeEl.appendChild(cloneChip);
        }, 310);
    },

    randomPosiElRect(coordinatesChipActive: DOMRect, wScale: number) {
        let flag = true;
        let xRandom = 0;
        let yRandom = 0;
        let maxRandomX = coordinatesChipActive.width;
        let maxRandomY = coordinatesChipActive.height;
        if (coordinatesChipActive.x > coordinatesChipActive.width) {
            maxRandomX = coordinatesChipActive.x + coordinatesChipActive.width;
        }
        if (coordinatesChipActive.y > coordinatesChipActive.height) {
            maxRandomY = coordinatesChipActive.y + coordinatesChipActive.height;
        }

        xRandom = this.getRandomInt(coordinatesChipActive.x, maxRandomX) - wScale;
        yRandom = this.getRandomInt(coordinatesChipActive.y, maxRandomY) - wScale;
        return {
            x: xRandom,
            y: yRandom,
        };
    },
    getRandomInt: (min: number, max: number) => {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    playClick: (el: HTMLAudioElement) => {
        el = new Audio(clickAudio);
        el.pause();
        el.currentTime = 0;
        el.play();
    },
    dealerSpeak: (el: HTMLAudioElement, url: string) => {
        el = new Audio(url);
        el.pause();
        el.currentTime = 0;
        el.volume = 0.5;
        el.play();
    },
    calcstatsTotal: (historyData: any[], statsCount: StatsCountMiniXD) => {
        historyData.forEach((item) => {
            const result = item.result.reduce((acc: number, num: number) => acc + num);
            if (result === 0) {
                // 4 trắng => chẵn, num0, xỉu
                statsCount.chan = (statsCount.chan || 0) + 1;
                statsCount.num0 = (statsCount.num0 || 0) + 1;
                statsCount.xiu = (statsCount.xiu || 0) + 1;
            } else if (result === 1) {
                // 3 trắng => lẻ, num1, xỉu
                statsCount.le = (statsCount.le || 0) + 1;
                statsCount.num1 = (statsCount.num1 || 0) + 1;
                statsCount.xiu = (statsCount.xiu || 0) + 1;
            } else if (result === 2) {
                // 2 trắng - 2 đỏ => chẵn, num2,
                statsCount.chan = (statsCount.chan || 0) + 1;
                statsCount.num2 = (statsCount.num2 || 0) + 1;
            } else if (result === 3) {
                // 3 đỏ => lẻ, num3, tài
                statsCount.le = (statsCount.le || 0) + 1;
                statsCount.num3 = (statsCount.num3 || 0) + 1;
                statsCount.tai = (statsCount.tai || 0) + 1;
            } else if (result === 4) {
                // 3 trắng => chẵn, num4, tài
                statsCount.chan = (statsCount.chan || 0) + 1;
                statsCount.num4 = (statsCount.num4 || 0) + 1;
                statsCount.tai = (statsCount.tai || 0) + 1;
            }
        });
        return statsCount;
    },
};

export const chatSuggestXD = [
    'quất mạnh tay chẵn',
    'quất mạnh tay lẻ',
    'bể cầu rồi',
    'ngon, húp trọn!',
    'đu xỉu tiếp nào',
    'Nay đen vãi',
    'anh zai ơi, Ai kéo em vào bờ với',
    'Cầu đẹp zô thôi!',
    'Chào các em, Anh đi rút tiền đây^^',
    'Đánh chẵn ra lẻ:(',
    'Ad chán vl',
    'Yêu ad vl',
];

export default xdFunction;
